export default "__VITE_ASSET__CoBckTKX__"